// extracted by mini-css-extract-plugin
var _1 = "TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "TableCellBase-moduleresizing__fe2t5 TableCell-moduleresizing__OfyAU";
var _3 = "TableCellBase-moduleshort__QGMTy";
var _4 = "TableCellBase-modulewithBorder__JPnqf TableCell-moduletableCellBorder__la700";
export { _1 as "TableCellBase", _2 as "resizing", _3 as "short", _4 as "withBorder" }
